export var EHanldeStatus;
(function (EHanldeStatus) {
    EHanldeStatus[EHanldeStatus["Add"] = 1] = "Add";
    EHanldeStatus[EHanldeStatus["Edit"] = 2] = "Edit";
})(EHanldeStatus || (EHanldeStatus = {}));
export default EHanldeStatus;
